import ContentAudio from './ContentAudio';
const isArray = Array.isArray;

class ContentAudioList {

    constructor(list) {
        this.parseData(list);
    }

    parseData (audio) {
        const cid = this.cid = {};
        const lang = this.language = {};
        const teams = this.teams = {};
        const list = this.list = [];

        if (audio) {
            audio = isArray(audio) ? audio : [audio];
            var item;
            var i = 0;
            var len = audio.length;

            for (; i < len; i++) {
                item = new ContentAudio(audio[i]);
                cid[item.id] = item;
                (lang[item.language] = lang[item.language] || []).push(item);
                (teams[item.team] = teams[item.team] || []).push(item);
                list.push(item);
            }
        }

        this.hasAudio = !!list.length;
    }

}

export default ContentAudioList;


